import { Heading, IconButton, icons } from "@/ui";

type CartHeaderProps = {
  cartCount: number;
  onClose: () => void;
};

export const CareplanCartHeader = ({ cartCount, onClose }: CartHeaderProps) => {
  const subtitle =
    cartCount === 0
      ? "Your cart is empty"
      : `Monthly subscription, ${cartCount} ${cartCount === 1 ? "product" : "products"}`;

  return (
    <div className="flex items-center justify-between gap-3 border-b border-line px-4 py-3.5 sm:px-6 sm:py-4">
      <div className="flex gap-3.5">
        <div className="relative top-1.5 w-fit">
          <icons.CartIcon aria-hidden="true" />
          <div className="absolute -top-1 -right-1 flex size-4 items-center justify-center rounded-full bg-surface-inverted text-xs text-content-on-inverted">
            {cartCount}
          </div>
        </div>
        <div>
          <Heading className="leading-tight sm:text-2xl" level={2}>
            Your Cart
          </Heading>
          <p className="text-base text-content-secondary">{subtitle}</p>
        </div>
      </div>
      <IconButton className="-mr-2 text-content-muted" label="Close cart" onClick={onClose}>
        <icons.XMarkIcon aria-hidden="true" className="size-7" />
      </IconButton>
    </div>
  );
};
